export default __webpack_public_path__ + "static/media/6.76225318.mp3";